var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flight",
    transform: "translate(-160 -56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 96,
    height: 96,
    rx: 48,
    transform: "translate(160 56)",
    fill: "#f0edf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Flight-2",
    "data-name": "Flight",
    d: "M11.281,1.006a1.124,1.124,0,0,0-.959.541A1.158,1.158,0,0,0,10.27,2.66l4.771,9.77-7.294.023L6.6,10.662a1.123,1.123,0,0,0-.942-.524H1.144a1.123,1.123,0,0,0-.937.506A1.158,1.158,0,0,0,.1,11.716L2.222,17,.1,22.291a1.158,1.158,0,0,0,.111,1.067,1.123,1.123,0,0,0,.933.5H5.653a1.123,1.123,0,0,0,.942-.515l1.15-1.773h7.318l-4.741,9.784a1.158,1.158,0,0,0,.055,1.107,1.124,1.124,0,0,0,.953.54h4.509a1.123,1.123,0,0,0,.924-.49l7.548-10.941h7.2a4.576,4.576,0,0,0,0-9.15H24.233L16.714,1.5a1.123,1.123,0,0,0-.924-.492ZM13.1,3.294H15.2l7.521,10.934a1.123,1.123,0,0,0,.92.485h7.864A2.241,2.241,0,0,1,33.763,17a2.275,2.275,0,0,1-.652,1.626,2.209,2.209,0,0,1-1.6.661H23.724a1.123,1.123,0,0,0-.92.492L15.255,30.716H13.143l4.739-9.777a1.158,1.158,0,0,0-.054-1.11,1.124,1.124,0,0,0-.958-.539H7.137a1.123,1.123,0,0,0-.942.519l-1.15,1.768H2.821l1.664-4.14a1.159,1.159,0,0,0,0-.862l-1.664-4.15H5.04l1.154,1.8a1.123,1.123,0,0,0,.947.519l9.717-.032a1.124,1.124,0,0,0,.955-.54,1.158,1.158,0,0,0,.055-1.108Z",
    transform: "translate(190.484 87.494)",
    fill: "#6a55a0",
    stroke: "#6a55a0",
    strokeWidth: 0.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/Flight.fa7f8310b279c14dadd10016ef258c06.svg";
export { ForwardRef as ReactComponent };